import { 
  Box,
  Skeleton,
  Grid,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStudentActions } from "../../../hooks/useStudentActions";
import { useEffect, useState } from "react";
import LoadingSkeleton from "../../../components/loading-skeleton";
import LecturePreviewCard from "./preview-card";
import { useSnackbar } from "../../../components/snackbar";
import axios from "axios";
import BackdropLoader from "../../../components/backdrop-loader";
import AccessExpired from "../../../components/access-expired";
import Lecture from "../../../models/lecture";

const API_URL = process.env.REACT_APP_API_URL;

export default function Lectures() {
  const { classroom_id } = useParams<{ classroom_id: string }>();
  

  const [loading, setLoading] = useState(false);

  const [joining, setJoining] = useState(false);


  const {
    classrooms, 
    getLectures
  } = useStudentActions();

  const classroom = classrooms?.[Number(classroom_id)];

  useEffect(() => {
    const loadLectures = async () => {
      await getLectures(Number(classroom_id));
    };

    setLoading(true);
    if (classroom && !classroom.lectures) loadLectures();
    setLoading(false);
  }, [classroom, classroom_id]);

  if (!classroom || !classroom.lectures || loading) {
    return (<LoadingSkeleton/>);
  }


  if (classroom.expiry_date && new Date() >= new Date(classroom.expiry_date)) {
    return <AccessExpired classroom_id={classroom_id!}/>
  }
  

  const lectureList = Object.values(classroom.lectures);
  
  return (
    <Box>
      {joining && <BackdropLoader/>}
      
      {lectureList.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            color: "text.secondary",
          }}
        >
          <Typography variant="h6" fontWeight={500}>
            No lectures available
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {lectureList
            .sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
            .map((lecture) => (
              <Grid key={lecture.id} size={{ xs: 12, md: 6, lg: 4 }}>
                <LecturePreviewCard lecture={lecture} setJoining={setJoining}/>
              </Grid>
            ))}
        </Grid>
      )}
     
    </Box>
  );
}
